// src/ScrollToTop.jsx
// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ScrollToTop = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: "instant" // use "smooth" if you want animation
//     });
//   }, [pathname]);

//   return null;
// };

// export default ScrollToTop;



// src/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const container = document.querySelector(".app-scroll-container");
    if (container) {
      container.scrollTo({
        top: 0,
        behavior: "smooth" // or "instant"
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
